import { Paper, Box, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useSwiper } from 'swiper/react';
import styles from './styles';

import { ReactFragmentIcon } from '../../kit/icons/ReactFragmentIcon';
import CVIcon from '../../kit/icons/CVIcon';

export default function CommonJsElement({
  phase,
  period,
  description,
  backgroundColor,
  minHeight,
  isLastElement,
}) {
  const isXs = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const swiper = useSwiper();
  const isSwiperLoaded = swiper?.slides?.length > 0;

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor,
        ...styles.root(isXs, minHeight, isSwiperLoaded || isXs),
      }}
    >
      <Box sx={styles.header(isXs)}>
        <Box style={styles.iconContainer()}>
          {!isLastElement && <ReactFragmentIcon />}
          {isXs && isLastElement && <CVIcon />}
          <Typography variant="desktopH4" color="kit.text.h" sx={styles.phase}>
            {phase}
          </Typography>
        </Box>

        <Typography variant="desktopP3" sx={styles.period}>
          {period}
        </Typography>
      </Box>
      <Typography
        color="kit.text.secondary"
        variant="desktopP2"
        sx={styles.description}
      >
        {description}
      </Typography>
    </Paper>
  );
}
